import classNames from 'classnames';
import { get } from 'lodash';
import { InputNumber, InputNumberProps } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';

const StyledIcon = styled.i`
  font-size: var(--xsmall-font-size);
  color: var(--gray-darker);
  cursor: pointer;
`;

export type FormikInputNumberProps = {
  field: {
    name: string;
    value: number;
    onChange: () => void;
    onBlur: (e: SyntheticEvent<HTMLInputElement>) => void;
  };
  form: {
    touched: Record<string, any>;
    errors: Record<string, any>;
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean,
    ) => void;
  };
  label?: string;
  icon?: string;
  tooltipId?: string;
  tooltip?: string;
  showError?: boolean;
};

export const FormikInputNumber: React.FC<
  FormikInputNumberProps & InputNumberProps
> = ({
  field,
  form,
  label,
  className,
  required,
  icon,
  tooltipId,
  tooltip,
  showError = true,
  ...rest
}) => {
  const fieldError = get(form.errors, field.name);
  const fieldTouched = get(form.touched, field.name);

  const handleValueChange = (e: any) => {
    form.setFieldValue(field.name, e.value);
  };

  return (
    <>
      <label
        htmlFor={field.name}
        className={classNames({
          'p-error': fieldTouched && !!fieldError,
        })}
      >
        {label}
        {required ? <span className="red"> *</span> : ''}
        {tooltip && tooltipId && (
          <>
            <Tooltip
              target={`#${tooltipId}`}
              position="top"
              content={tooltip}
              my="center bottom-10"
            />
            <StyledIcon className="pi pi-info-circle ml-1" id={tooltipId} />
          </>
        )}
      </label>
      {icon ? (
        <div className="p-input-icon-right w-full">
          <InputNumber
            id={field.name}
            name={field.name}
            value={field.value}
            onValueChange={handleValueChange}
            onBlur={field.onBlur}
            {...rest}
            className={classNames(className, {
              'p-invalid': fieldTouched && !!fieldError,
            })}
          />
          <i className={icon} />
        </div>
      ) : (
        <InputNumber
          id={field.name}
          name={field.name}
          value={field.value}
          onValueChange={handleValueChange}
          onBlur={field.onBlur}
          {...rest}
          className={classNames(className, {
            'p-invalid': fieldTouched && !!fieldError,
          })}
        />
      )}
      {showError && fieldTouched && !!fieldError ? (
        <small className="p-error">{fieldError}</small>
      ) : null}
    </>
  );
};
